import { useContext } from 'react';
import { useMutation } from 'react-query';
import { documentApi } from '../../../../api/document';
import { sanitizeDocumentSections } from '../../../../util/DocumentSectionSanitizer';
import { DocumentOverviewContext } from '../../DocumentOverview/Context';
import { TrainingAiAssessmentApi } from '../api/trainingAi';

export const useGenerateTrainingAssessment = () => {
  const { qualioDocument } = useContext(DocumentOverviewContext);

  return useMutation({
    mutationFn: async () => {
      const latestDocument = await documentApi.fetch(
        qualioDocument.id.toString(),
      );
      return TrainingAiAssessmentApi.generateTrainingAssessment(
        latestDocument.title,
        sanitizeDocumentSections(latestDocument.sections),
      );
    },
    // PS-238: a 422 means the backend declined to generate because the document
    // content is junk / placeholder / blank.
    // PS-235: a 413 (CONTEXT_WINDOW_EXCEEDED) means the document content is too
    // large to fit the model's context window.
    // A 503 (MODEL_UNAVAILABLE) means Bedrock is transiently out of capacity.
    // The backend asks for a ~10s Retry-After, so silent react-query
    // retries (~1/2/4s) would just hammer it and still fail. Surface the
    // "temporarily unavailable" message instead and let the user retry.
    // All three are non-retryable here — do not retry them; other failures keep
    // the existing 3 retries.
    retry: (failureCount, error: any) => {
      const status = error?.response?.status;
      if (status === 422 || status === 413 || status === 503) {
        return false;
      }
      return failureCount < 3;
    },
  });
};
